<div>
  <nz-select
    class="mr-[8px] mb-[12px] w-[100px]"
    nzSize="large"
    [nzOptions]="listOfCycleOption"
    [nzDropdownMatchSelectWidth]="false"
    [(ngModel)]="value.frequency"
    (ngModelChange)="onValueChange()"></nz-select>
  <nz-select
    class="mr-[8px] w-[100px]"
    nzSize="large"
    [nzOptions]="listOfWeekday"
    [nzDropdownMatchSelectWidth]="false"
    [(ngModel)]="value.day_of_week"
    (ngModelChange)="onValueChange()"></nz-select>
  <span class="mr-[8px]">
    {{ "automation-message_rules_html_specific_at" | translate }}
    <!-- at -->
  </span>
  <nz-select
    class="mr-[8px] w-[120px]"
    nzSize="large"
    [nzOptions]="listOfTimeOptions"
    [nzDropdownMatchSelectWidth]="false"
    [nzCustomTemplate]="formatTimeTpl"
    [(ngModel)]="at"
    (ngModelChange)="onAtChange()"></nz-select>
  <ng-template #formatTimeTpl let-selected>
    <!-- 之所以加一个日期前缀，是因为 dateformat 接受的是一个有效的日期格式，仅有时间不是一个有效的格式，所以这里利用一个随机日期将其拼接完整 -->
    {{ "2023-11-11T" + selected.nzLabel | dateformat: [null, "hm"] }}
  </ng-template>
  <span class="mr-[8px]">
    {{ "automation-message_rules_html_specific_during" | translate }}
    <!-- during the guest's stay -->
  </span>
  <nz-select
    class="mr-[8px] w-[110px]"
    nzSize="large"
    [nzOptions]="listOfCondition"
    [nzDropdownMatchSelectWidth]="false"
    [(ngModel)]="value.condition"
    (ngModelChange)="onValueChange()"></nz-select>
  <span>
    {{ "automation-message_rules_html_checkin_day" | translate }}
    <!-- the check-in day -->
  </span>
</div>
